import { TCategoriesParams, TGetCategoriesResponse } from './categories.types'

export async function getCategories(params: TCategoriesParams) {
  const data = await makeRequest<
    TGetCategoriesResponse,
    TGetCategoriesResponse['items']
  >('/api/categories', {
    params,
    transform(res) {
      return res?.items || []
    },
  })

  return data
}
